import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideClientHydration } from '@angular/platform-browser';
import {  HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi} from "@angular/common/http";
import { AuthInterceptor } from './auth/auth.interceptor';
import { provideToastr } from 'ngx-toastr';
import { provideAnimations } from '@angular/platform-browser/animations';
import { SocketConfigModule } from './socket.config';

export const appConfig: ApplicationConfig = {
  providers: [
    // importProvidersFrom(
    //   ToastrModule.forRoot({
    //     timeOut: 2000,
    //     preventDuplicates: true,
    //     maxOpened: 1,
    //   }),
    // ),
    provideZoneChangeDetection({ eventCoalescing: true }), 
    provideRouter(routes), 
    provideClientHydration(),
    provideAnimations(),
    provideToastr(),
    provideHttpClient(
      withInterceptorsFromDi(),
    ),
    { 
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor, 
      multi: true 
    },
    importProvidersFrom(SocketConfigModule),
  ] 
};
